import React from 'react';
import styled from 'styled-components';

interface FinancialProps {
  title: string;
  children: React.ReactNode;
  info?: boolean;
}

export const CardWrapper = styled.div`
  background: #ffffff;
  border: 1px solid #0000000d;
  border-radius: 20px;

  .card-title {
    border-bottom: 1px solid #0000000d;
    font-size: 14px;
    font-weight: 500;
    line-height: 16.8px;
    text-align: left;
    color: #001317;
    padding-inline: 14px;

    h4 {
      font-size: 14px;
      font-weight: 500;
      line-height: 16.8px;
      text-align: left;
      color: #001317;
      padding: 16px;
      font-family: 'PP Neue Montreal', sans-serif;
      display: inline-block;
      position: relative;

      &::after {
        position: absolute;
        content: '';
        background-color: #001316;
        width: 100%;
        height: 1px;
        left: 0;
        border-radius: 2px;
        bottom: 0;
      }
    }
  }

  .card-content {
    padding: 14px;

    @media screen and (max-width: 767px) {
      padding: 30px 10px;
    }
  }
`;

const CardContentHolder = styled.div<{ placing?: boolean }>`
  display: ${({ placing }) => (placing ? 'flex' : 'block')};
  justify-content: space-between;
  align-items: baseline;

  .info_list {
    display: flex;
    flex-direction: row;
    justify-content: end;
    .info_listing_child {
      display: flex;
      justify-content: space-between;
      align-items: baseline;
      position: relative;
      .green_revenue {
        width: 13px;
        height: 13px;
        background-color: #00b9ae;
        border-radius: 3px;
        position: absolute;
        top: 2px;
      }
      .blue_revenue {
        width: 13px;
        height: 13px;
        background-color: #037171;
        border-radius: 3px;
        position: absolute;
        top: 2px;
      }
      h5 {
        font-size: 14px;
        font-weight: 600;
        margin-left: 16px;
        color: #000;
        width: auto;
      }
    }
  }
  h5 {
    font-family: 'PP Neue Montreal', sans-serif;
    font-size: 14px;
    font-weight: 500;
    line-height: 16.8px;
    text-align: right;
    padding-right: 30px;
    padding-bottom: 20px;
    color: #ababab;
  }
`;

// eslint-disable-next-line @typescript-eslint/no-unused-vars, sonarjs/no-unused-function-argument
export const Card: React.FC<FinancialProps> = ({ title, children, info }) => {
  return (
    <CardWrapper>
      <div className="card-content">
        <CardContentHolder>
          <div className="info_list">
            <div className="info_listing_child">
              <div className="green_revenue"></div>
              <h5>Delivery Volume</h5>
            </div>
            <div className="info_listing_child">
              <div className="blue_revenue"></div>
              <h5>Total Volume</h5>
            </div>
          </div>
        </CardContentHolder>
        {children}
      </div>
    </CardWrapper>
  );
};
